



























import Vue from "vue";
import { Component, Watch, Prop } from "vue-property-decorator";

@Component
export default class NumberPad extends Vue {
  // props
  @Prop(String) readonly dataType: string | undefined;
  @Prop(String) readonly dataAmount!: string;
  // data
  amount = this.dataAmount.toString();
  // watch
  // @Watch("dataAmount")
  // onDataAmountChange(val: string, oldVal: string) {
  //   console.log(val);
  // }
  // methods
  inputContent(event: MouseEvent) {
    const button = event.target as HTMLButtonElement;
    const input = button.textContent as string;
    if (this.amount.length === 8) {
      return;
    }
    if (this.amount === "0") {
      if ("0123456789".indexOf(input) >= 0) {
        this.amount = input;
      } else {
        this.amount += input;
      }
    } else if (this.amount.indexOf(".") >= 0 && input === ".") {
      return;
    } else {
      this.amount += input;
    }
    this.$emit("update:dataAmount", this.amount);
  }
  clear() {
    this.amount = "0";
    this.$emit("update:dataAmount", this.amount);
  }
  backSpace() {
    if (this.amount.length === 1) {
      this.amount = "0";
    } else {
      this.amount = this.amount.slice(0, -1);
    }
    this.$emit("update:dataAmount", this.amount);
  }
  ok() {
    this.$emit("submit", this.amount);
    this.amount = "0";
    this.$emit("update:dataAmount", this.amount);
  }
}
